import { SummaryRow } from "../../pages/siteIntelligence/site/detail/sections/SummaryTable";

export function formatFieldName(key: string): string {
    return key
        .replace(/_/g, " ") // replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize first letter of each word
};

export default function formatSummaryRowByKey(data: Record<string, any> | null | undefined): SummaryRow[] {
    const emDash = '—';
    const summaryRow: SummaryRow[] = [];

    if (!data) return summaryRow;

    const traverse = (obj: Record<string, any>, parentKey?: string) => {
        for (const [key, value] of Object.entries(obj)) {
            const combinedKey = parentKey ? `${parentKey} ${emDash} ${key}` : key;

            if (value === null || value === undefined) continue;

            if (typeof value === "object" && !Array.isArray(value)) {
                // Go one level deeper
                traverse(value, combinedKey);
            } else {
                summaryRow.push({
                    key: combinedKey,
                    field: formatFieldName(combinedKey),
                    render: () => (
                        <div
                            title={String(value)}
                        >
                            {(value !== null && value !== undefined && value !== '') ? String(value) : emDash}
                        </div>
                    ),
                });
            }
        }
    };

    traverse(data);
    return summaryRow;
}